<template>
  <div class="row bg-white"
       :style="props.embedded ? 'height: 100%; display: flex; flex-direction: column; margin: 0;' : ''">
    <div class="col-12"
         :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; padding: 0;' : ''">
      <div class="row gy-2"
           :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; margin: 0;' : ''">

        <div v-if="!props.embedded" class="col-12">
          <div class="dash-filterbar">
            <NSelect v-model:value="FILTERS.ELEMENT" :disabled="isLoading" :options="ELEMENT_OPTS" :theme-overrides="inputTheme" filterable clearable placeholder="Select commodity to view" :input-props="{ autocomplete: Math.random() }" class="dash-filterbar__select" size="small" />
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">Start</span>
              <NDatePicker v-model:value="yearsView[0]" type="year" clearable :is-date-disabled="disableOutOfRange" :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
            </div>
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">End</span>
              <NDatePicker v-model:value="yearsView[1]" type="year" clearable :is-date-disabled="disableOutOfRange" :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
            </div>
            <NButton size="small" :disabled="isDisabled" @click="getTableData()" color="#213ce5" style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;" @mouseenter="(e) => e.currentTarget.style.border = '1px solid #00aeef'" @mouseleave="(e) => e.currentTarget.style.border = '1px solid transparent'">Search</NButton>
          </div>

          <!-- Action row -->
          <div class="dash-actions">
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType==='Table' }" @click="setType('Table')">
              <img :src="DDICONS.table" alt="" class="dash-action-btn__icon" />
              View as table
            </button>
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType==='Graph' }" @click="setType('Graph')">
              <img :src="DDICONS.graphic" alt="" class="dash-action-btn__icon" />
              View as Graphic
            </button>
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType==='All' }" @click="setType('All')">
              <img :src="DDICONS.graphTable" alt="" class="dash-action-btn__icon" />
              View Table &amp; Graphic
            </button>

            <div class="relative inline-block" @focusout="e => { if (!e.currentTarget.contains(e.relatedTarget)) setTimeout(() => menuOpen = false, 100) }">
              <button class="dash-action-btn" :disabled="!activeData || activeData.length === 0" @click="menuOpen = !menuOpen">
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                {{ displayType === 'Graph' ? 'Export Graphic' : displayType === 'All' ? 'Export' : 'Export Data' }}
              </button>
              <div v-show="menuOpen" class="split-menu" role="menu">
                <template v-if="displayType !== 'Graph'"><button role="menuitem" @click="handleExportExcel">Export as Excel</button><button role="menuitem" @click="handleExportCSV">Export as CSV</button></template>
                <template v-if="displayType !== 'Table'"><button role="menuitem" @click="exportAs('png')">Export as PNG</button><button role="menuitem" @click="exportAs('svg')">Export as SVG</button></template>
              </div>
            </div>
            <template v-if="displayType === 'Graph' || displayType === 'All'">
              <NSwitch v-model:value="isSingle" :rail-style="railStyle" :disabled="!activeData || activeData.length === 0" :round="false" size="small"><template #checked>Single-axis</template><template #unchecked>Secondary axis</template></NSwitch>
              <NSelect v-model:value="leftAxisLabel" :options="products" :theme-overrides="inputTheme" :disabled="!activeData || activeData.length === 0" placeholder="Left axis" :input-props="{ autocomplete: Math.random() }" size="small" />
              <NSelect v-model:value="rightAxisLabel" :options="products" :theme-overrides="inputTheme" :disabled="!activeData || activeData.length === 0" placeholder="Right axis" :input-props="{ autocomplete: Math.random() }" size="small" />
            </template>
            <span class="dash-actions__disclaimer" @click="showDisclaimer = true"><em>Disclaimer</em></span>
          </div>
        </div>

        <div v-if="needsRefresh && !props.embedded" class="col-12">
          <div class="dash-empty-state">
            Select a commodity, then click&nbsp;<strong>Search</strong>&nbsp;to load data.
          </div>
        </div>

        <div v-if="!needsRefresh && !props.embedded && (displayType == 'Table' || displayType == 'All')" class="col-12">
          <div class="table-scroll modern-scrollbar" style="overflow-x: visible;">
            <NDataTable :columns="columns" :data="tableData" :row-key="rowKey" :scroll-x="tableWidth" table-layout="fixed" />
          </div>
        </div>

        <!-- ── Chart block ─────────────────────────────────────────────────── -->
        <div v-if="(props.embedded || !needsRefresh) && (displayType == 'Graph' || displayType == 'All')"
             :class="props.embedded ? '' : 'col-12'"
             :style="props.embedded
               ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; padding: 0; margin-top: 0'
               : ''">
          <div oncontextmenu="return false;"
               style="background-color: white;"
               ref="captureDiv"
               :style="props.embedded
                 ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;'
                 : ''">
            <div
                style="background: url('https://driqq8crwypb5.cloudfront.net/articles/projectblue-data-dash-image.png') center/cover no-repeat; background-size: 60%;"
                :style="props.embedded
                  ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; background-color: #f8f9fa;'
                  : 'background-color: rgba(255,255,255,0.8); padding: 20px;'">
              <div style="position: relative;"
                   :style="props.embedded
                     ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; background-color: #f8f9fa;'
                     : 'background-color: rgba(255,255,255,0.8); padding: 20px;'">

                <!-- Loading overlay -->
                <div v-show="isChartLoading"
                     style="position: absolute; inset: 0; display: flex; flex-direction: column;
                            align-items: center; justify-content: center; background: white;
                            z-index: 10; gap: 1.5rem;">
                  <div class="custom-loader">
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                  </div>
                  <p class="loading-text">Loading...</p>
                </div>

                <DynamicChart
                    v-if="!isSingle"
                    v-show="!isChartLoading"
                    ref="dynamicChartRef"
                    :chartData="chartData"
                    :options="embeddedOptions"
                    :chart-type="graphView"
                    :key="legendKey"
                    :height="props.embedded ? '100%' : '500px'"
                    :embedded="props.embedded"
                    :style="props.embedded ? 'flex: 1; min-height: 0;' : ''"
                />
                <DemandChart
                    v-if="isSingle"
                    :chartData="chartDataSingle"
                    :options="optionsSingle"
                    :chart-type="graphView"
                    :key="legendKey"
                />
              </div>
            </div>
          </div>
          <p v-if="!props.embedded" style="font-size: smaller;"><em>Source: Project Blue. Price data compiled by Project Blue from Project Blue data and multiple price reporting agencies.</em></p>
          <p v-if="!props.embedded" style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
        </div>

        <p v-if="!props.embedded && displayType == 'Table'" style="font-size: smaller;"><em>Source: Project Blue. Price data compiled by Project Blue from Project Blue data and multiple price reporting agencies.</em></p>
        <p v-if="!props.embedded && displayType == 'Table'" style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
      </div>
    </div>
  </div>

  <NDrawer v-model:show="showDisclaimer" :width="400" :height="200" placement="right">
    <TermsAndConditions />
  </NDrawer>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, nextTick } from "vue";
import { NSelect, NDataTable, NDatePicker, NButton, NDrawer, NSwitch } from "naive-ui";
import DynamicChart from "@/components/DynamicChart.vue";
import { SUBSCRIPTION_INFO } from "@/composables/subscription";
import { getPriceData, priceData, getCommodityProductsAndCountries, getPriceMetadata, priceMetadata } from "@/composables/marketData/datadashboards";
import * as htmlToImage from 'html-to-image';
import TermsAndConditions from "./TermsAndConditions.vue";
import DemandChart from "../../components/DemandChart.vue";
import { exportToCSV, exportToExcel } from "../../composables/marketData/datadashboards";
import { DDICONS } from "../../composables/generics";
import { logUserAction, logUserActionDebounced, USER_ACTIONS } from "@/composables/userLogs";

const props = defineProps({
  embedded: { type: Boolean, default: false },
  embeddedFilters: { type: Object, default: null },
});
const emit = defineEmits(['products-loaded']);

// ── Embedded title (mirrors MarketDataDashboard) ───────────────────────────────
const embeddedTitle = computed(() => {
  if (!ELEMENT_OPTS.value) return FILTERS.ELEMENT ?? '';
  return ELEMENT_OPTS.value.find(x => x.value === FILTERS.ELEMENT)?.label ?? FILTERS.ELEMENT ?? '';
});

// ── embeddedOptions computed (mirrors MarketDataDashboard exactly) ─────────────
const embeddedOptions = computed(() => ({
  ...options.value,
  maintainAspectRatio: props.embedded ? false : options.value.maintainAspectRatio,
  height: props.embedded ? undefined : options.value.height,
  plugins: {
    ...options.value.plugins,
    legend: {
      ...options.value.plugins.legend,
    },
    title: {
      display: props.embedded && !!embeddedTitle.value,
      text: embeddedTitle.value,
      align: 'center',
      position: 'top',
      color: 'black',
      font: { size: 16 },
      padding: { top: 8, bottom: 4 },
    },
  },
  scales: {
    ...options.value.scales,
    x: { ...options.value.scales.x },
    yLeft: { ...options.value.scales.yLeft },
    yRight: { ...options.value.scales.yRight, display: !!rightAxisLabel.value && leftAxisLabel.value !== rightAxisLabel.value },
  },
}));

const randomId = ref(Math.random().toString());
const isChartLoading = ref(false);
const dynamicChartRef = ref(null);

const inputTheme = {
  peers: {
    InternalSelection: { borderHover: '1px solid #213ce5', borderFocus: '1px solid #213ce5', borderActive: '1px solid #213ce5', boxShadowFocus: '0 0 0 2px rgba(33, 60, 229, 0.2)', boxShadowActive: '0 0 0 2px rgba(33, 60, 229, 0.2)', boxShadowHover: 'none', caretColor: '#213ce5', arrowColorActive: '#213ce5', arrowColorHover: '#213ce5', color: '#fff', colorActive: '#ffffff', colorFocus: '#ffffff', fontFamily: "'GilroyMedium', sans-serif", fontSize: '11px !important' },
    InternalSelectMenu: { optionColorActive: 'rgba(33, 60, 229, 0.08)', optionColorActivePending: 'rgba(33, 60, 229, 0.12)', optionColorPending: 'rgba(33, 60, 229, 0.05)', optionTextColorActive: '#213ce5', optionTextColorChildActive: '#213ce5', optionCheckColor: '#213ce5', actionDividerColor: '#213ce5', loadingColor: '#213ce5', scrollbarColor: 'rgba(33, 60, 229, 0.3)', scrollbarColorHover: 'rgba(33, 60, 229, 0.5)', fontFamily: "'GilroyMedium', sans-serif", fontSize: '11px !important' }
  }
};

const handleClickOutside = (e) => { if (!e.target.closest('.relative.inline-block')) menuOpen.value = false; };

const ELEMENT_OPTS = computed(() => SUBSCRIPTION_INFO?.dataElements?.map((nth) => ({ label: nth.name, value: nth.code })));

// Full-page filter state — never written to in embedded mode
const FILTERS = reactive({ ELEMENT: null });

// Embedded mode uses its own local data ref — shared priceData ref is never left dirty
const localPriceData = ref([]);

// All internal logic reads from here
const activeData = computed(() => props.embedded ? localPriceData.value : (priceData.value ?? []));

const GRAPH_VIEW_OPTIONS = ref([{ label: 'Default', value: 'stacked' }, { label: 'Line Chart', value: 'line' }, { label: 'Bar Chart', value: 'bar' }]);
const legendKey = ref(0);
const decimals = ref(1);
const isSearch = ref(false);
const isSingle = ref(false);
const lastYearStart = ref(2015);
const lastYearEnd = ref(2035);
const showDisclaimer = ref(false);
const captureDiv = ref(null);
const showOptions = ref(false);
const isLoading = ref(true);
const needsRefresh = ref(false);
let isMounted = false;
const displayType = ref("Graph");
const menuOpen = ref(false);
const graphView = ref(GRAPH_VIEW_OPTIONS.value[0].value);
const leftAxisLabel = ref("");
const rightAxisLabel = ref("");
const yearsView = ref([(new Date(2015, 0)).getTime(), (new Date(2035, 0)).getTime()]);
const updatedDate = ref(new Date());

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);
  if (!props.embedded) {
    FILTERS.ELEMENT = sessionStorage.getItem("element") ?? ELEMENT_OPTS.value[0].value;
    isLoading.value = false;
    displayType.value = localStorage.getItem("displayTypePrice") ?? "Table";

    await initializeFilters(FILTERS.ELEMENT);
    await getTableData();
    isMounted = true;
  } else {
    isLoading.value = false;
    displayType.value = "Graph";
  }
});

onUnmounted(() => document.removeEventListener('click', handleClickOutside));

// Isolated fetch for embedded mode
async function fetchEmbedded(element, leftAxis, rightAxis) {
  if (!element) return;
  FILTERS.ELEMENT = element;
  isChartLoading.value = true;

  // Same source of truth the non-embedded view initializes from, so the
  // embedded date range matches it instead of being derived from whatever
  // data happens to come back for the (still-default) query window.
  await getPriceMetadata(element);
  if (selectedElementInfo.value) {
    yearsView.value = [
      new Date(selectedElementInfo.value.startYear, 0).getTime(),
      new Date(selectedElementInfo.value.endYear, 0).getTime()
    ];
  }

  await getPriceData(element, null, null, new Date(yearsView.value[0]).getFullYear(), new Date(yearsView.value[1]).getFullYear());
  localPriceData.value = JSON.parse(JSON.stringify(priceData.value ?? []));
  priceData.value = [];

  const productList = localPriceData.value.map(x => x.productForm);
  emit('products-loaded', productList.map(p => ({ label: p, value: p })));

  if (leftAxis == null && rightAxis == null) {
    // Neither axis explicitly chosen — default to the first product so something renders
    leftAxisLabel.value  = productList[0] ?? '';
    rightAxisLabel.value = '';
  } else if (leftAxis == null && rightAxis != null) {
    // Only the right axis was picked — normalize a single selection onto the left axis
    leftAxisLabel.value  = rightAxis;
    rightAxisLabel.value = '';
  } else {
    // Respect explicit selections (and explicit clears) as-is
    leftAxisLabel.value  = leftAxis  ?? '';
    rightAxisLabel.value = rightAxis ?? '';
  }

  // When only a single product is shown, narrow the range to what that
  // product's own data actually covers, instead of the full commodity range
  // (which may span years other products have data for but this one doesn't).
  // Derived from the actual populated yearlyData keys rather than the
  // startYear/endYear metadata, since that metadata can just echo back
  // whatever window was queried rather than the product's true extent.
  if (leftAxisLabel.value && !rightAxisLabel.value) {
    const singleProduct = localPriceData.value.find(x => x.productForm === leftAxisLabel.value);
    const populatedYears = Object.entries(singleProduct?.yearlyData || {})
      .filter(([, v]) => v !== null && v !== undefined && v !== '')
      .map(([y]) => Number(y));
    if (populatedYears.length) {
      yearsView.value = [
        new Date(Math.min(...populatedYears), 0).getTime(),
        new Date(Math.max(...populatedYears), 0).getTime()
      ];
    }
  }

  decimals.value = localPriceData.value[0]?.decimalPlaces ?? 1;
  getChartData();
  graphView.value = GRAPH_VIEW_OPTIONS.value[1].value;
  isSearch.value = true;
  await nextTick();
  await new Promise(r => setTimeout(r, 400));
  isChartLoading.value = false;
  await nextTick();
  dynamicChartRef.value?.renderChart(embeddedTitle.value);
}

// Re-fetch when dashboard applies new filters
watch(() => props.embeddedFilters, (newFilters) => {
  if (!props.embedded || !newFilters?.element) return;
  fetchEmbedded(newFilters.element, newFilters.leftAxis, newFilters.rightAxis);
}, { deep: true });

function setType(type) {
  displayType.value = type;
  if (!props.embedded) localStorage.setItem("displayTypePrice", type);
  // Track display mode switch (Table, Graph, All)
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Switched Prices view to: "${type}" (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
}

function railStyle({ focused, checked }) {
  const style = {
    fontSize: '14px',
    border: '1px solid transparent',
    height: '20px',
  };
  style.background = 'linear-gradient(90deg, #213ce5, #2380f2)';
  if (focused) {
    style.boxShadow = 'none';
  }
  return style;
}

const exportAs = (type) => {
  menuOpen.value = false;
  // Track graphic download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_GRAPH,
    `Exported Prices graphic as ${type.toUpperCase()} (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
  type === 'svg' ? downloadAsSvg() : downloadAsPng();
};

const handleExportExcel = () => {
  menuOpen.value = false;
  exportToExcel(tableData.value, minYear.value, maxYear.value, 'Prices.xlsx', 'price');
  // Track spreadsheet download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Prices data as Excel (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const handleExportCSV = () => {
  menuOpen.value = false;
  exportToCSV(tableData.value, minYear.value, maxYear.value, 'Prices.csv', 'price');
  // Track CSV download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Prices data as CSV (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const downloadAsSvg = () => { htmlToImage.toSvg(captureDiv.value).then(dataUrl => { const link = document.createElement("a"); link.download = "capture.svg"; link.href = dataUrl; link.click(); }); };
const downloadAsPng = () => { htmlToImage.toPng(captureDiv.value).then(dataUrl => { const link = document.createElement("a"); link.download = "capture.png"; link.href = dataUrl; link.click(); }); };

const products = computed(() => (activeData.value || []).map(x => ({ label: x.productForm, value: x.productForm })));

const unitFor = (productForm) => (activeData.value || []).find(x => x.productForm === productForm)?.units ?? '';
const axisTitle = (productForm) => {
  if (!productForm) return '';
  const unit = unitFor(productForm);
  return unit ? `${productForm} (${unit})` : productForm;
};

const minYear = computed(() => {
  if (!activeData.value?.length) return null;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  const minY = Math.min(...activeData.value.map(x => x.startYear).filter(y => y != null));
  const min = allYears.length ? Math.min(...allYears) : null;
  return minY == 'Infinity' ? min : min > minY ? min : minY;
});
const maxYear = computed(() => {
  if (!activeData.value?.length) return null;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  const maxY = Math.max(...activeData.value.map(x => x.endYear).filter(y => y != null));
  const max = allYears.length ? Math.max(...allYears) : null;
  return maxY == '-Infinity' ? max : max > maxY ? max : maxY;
});
const minFilterYear = computed(() => {
  if (!activeData.value?.length) return 2015;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  const minY = Math.min(...activeData.value.map(x => x.startYear).filter(y => y != null));
  const min = allYears.length ? Math.min(...allYears) : null;
  return minY == 'Infinity' ? min : min < minY ? min : minY;
});
const maxFilterYear = computed(() => {
  if (!activeData.value?.length) return 2035;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  const maxY = Math.max(...activeData.value.map(x => x.endYear).filter(y => y != null));
  const max = allYears.length ? Math.max(...allYears) : null;
  return maxY == '-Infinity' ? max : max > maxY ? max : maxY;
});

const disableOutOfRange = (timestamp) => {

    const year = new Date(timestamp).getFullYear();

    if (selectedElementInfo.value) {

        return (
            year < selectedElementInfo.value.startYear ||
            year > selectedElementInfo.value.endYear
        );

    }

    return (
        year < minFilterYear.value ||
        year > maxFilterYear.value
    );

}

const tableData = computed(() => {
  const startYears = (activeData.value || []).map(d => d.startYear);
  const endYears   = (activeData.value || []).map(d => d.endYear);
  lastYearStart.value = Math.min(...startYears) || 2015;
  lastYearEnd.value   = Math.max(...endYears)   || 2035;
  return (activeData.value || []).map(item => {
    const copy = { ...item };
    const years = copy.yearlyData;
    if (years && typeof years === 'object' && !Array.isArray(years)) {
      for (const [year, value] of Object.entries(years)) {
        copy[year] = value.toLocaleString('en', { minimumFractionDigits: decimals.value, maximumFractionDigits: decimals.value });
      }
    }
    delete copy.yearlyData;
    return copy;
  });
});

let measureCtx = null;
function measureTextWidth(text, font = '14px sans-serif') {
  if (!measureCtx) measureCtx = document.createElement('canvas').getContext('2d');
  measureCtx.font = font;
  return measureCtx.measureText(text ?? '').width;
}

const productFormWidth = computed(() => {
  const longest = (tableData.value || []).reduce((max, row) => Math.max(max, measureTextWidth(row.productForm)), measureTextWidth('Product Form'));
  return Math.ceil(longest) + 24; // cell padding
});

const unitsWidth = computed(() => {
  const longest = (tableData.value || []).reduce((max, row) => Math.max(max, measureTextWidth(row.units)), measureTextWidth('Units'));
  return Math.ceil(longest) + 24; // cell padding
});

const columns = computed(() => {
  let  columnStart = minYear.value;
  let columnEnd   = maxYear.value;
  if (FILTERS.ELEMENT) {
    columnStart = new Date(yearsView.value[0]).getFullYear();
    columnEnd = new Date(yearsView.value[1]).getFullYear();
  }
  const response = [
    { title: "Product Form", key: 'productForm', width: `${productFormWidth.value}px`, fixed: 'left' },
    { title: 'Units', key: 'units', width: `${unitsWidth.value}px`, fixed: 'left' },
    ...Array.from({ length: columnEnd - columnStart + 1 }, (_, i) => ({ title: `${columnStart + i}`, key: `${columnStart + i}`, width: '110px', align: 'right' }))
  ];
  lastYearStart.value = isSearch.value ? new Date(yearsView.value[0]).getFullYear() : lastYearStart.value;
  lastYearEnd.value   = isSearch.value ? new Date(yearsView.value[1]).getFullYear() : lastYearEnd.value;
  isSearch.value = false;
  return response;
});

const tableWidth = computed(() => productFormWidth.value + unitsWidth.value + ((columns.value.length - 2) * 110));

const rowKey = (row) => row.countries;
const chartData = ref({ labels: [], datasets: [] });
const chartDataSingle = ref({ labels: [], datasets: [] });

const getChartData = () => {
  const start = new Date(yearsView.value[0]).getFullYear();
  const end = new Date(yearsView.value[1]).getFullYear();
  const years = Array.from({ length: Math.max(0, end - start + 1) }, (_, i) => start + i);
  const colors = ['#213CE5','#00AEEF','#009A46','#92D050','#F0C302','#6801FF','#9484FF','#f25c05','#FC9860','#F58231','#911EB4','#46F0F0','#F032E6','#D2F53C','#FABEBE','#008080'];
  const colorFor = i => colors[i % colors.length];
  const numericVals = obj => Object.values(obj || {}).map(v => { const n = Number(v); return Number.isFinite(n) ? n : null; }).filter(v => v !== null);
  const labelValue = (refVal) => { if (refVal == null) return ''; if (typeof refVal === 'string') return refVal.trim(); if (typeof refVal === 'object' && refVal.label != null) return String(refVal.label).trim(); return String(refVal).trim(); };

  let datasets = (activeData.value || []).slice()
      .sort((a, b) => { const maxA = numericVals(a.yearlyData).reduce((m, v) => Math.max(m, v), -Infinity); const maxB = numericVals(b.yearlyData).reduce((m, v) => Math.max(m, v), -Infinity); return maxB - maxA; })
      .map((item, idx) => {
        const yearly = item.yearlyData || {};
        const data = years.map(y => { const v = yearly[String(y)]; return (v === undefined || v === null || v === '') ? null : Number(v); });
        const hex = colorFor(idx).replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16); const g = parseInt(hex.substring(2, 4), 16); const b = parseInt(hex.substring(4, 6), 16);
        const productForm = (item.productForm || `Series ${idx + 1}`).trim();
        return { label: axisTitle(productForm) || productForm, productForm, data, borderColor: colorFor(idx), backgroundColor: `rgba(${r}, ${g}, ${b}, 1)`, borderWidth: 2, yAxisID: 'yLeft', fill: false, stacked: false, type: 'line', order: idx };
      });

  const leftLabel  = labelValue(leftAxisLabel?.value);
  const rightLabel = labelValue(rightAxisLabel?.value);
  const leftDataSet  = datasets.find(d => d.productForm === leftLabel);
  const rightDataSet = datasets.find(d => d.productForm === rightLabel);
  if (rightDataSet && rightDataSet !== leftDataSet) rightDataSet.yAxisID = 'yRight';
  let finalDatasets = [];
  if (leftDataSet) finalDatasets.push(leftDataSet);
  if (rightDataSet && rightDataSet !== leftDataSet) finalDatasets.push(rightDataSet);
  if (finalDatasets.length === 0) { finalDatasets = datasets.slice(0, 2); if (finalDatasets.length === 2) finalDatasets[1].yAxisID = 'yRight'; }

  options.value.scales.yLeft.title.text = axisTitle(leftLabel);
  options.value.scales.yRight.title.text = axisTitle(rightLabel);

  chartData.value = { labels: years, datasets: finalDatasets };
  getChartDataSingle(years, datasets, labelValue);
};

const getChartDataSingle = (years, datasets, labelValue) => {
  const leftLabel  = labelValue(leftAxisLabel?.value);
  const rightLabel = labelValue(rightAxisLabel?.value);
  const selected = datasets.filter(d => d.productForm === leftLabel || (rightLabel && d.productForm === rightLabel));
  chartDataSingle.value = { labels: years, datasets: selected.map(ds => ({ ...ds, yAxisID: 'y' })) };
};

const isDisabled = computed(() => !FILTERS?.ELEMENT);

// Full-page only — uses shared composable ref
const getTableData = async () => {
  needsRefresh.value = false;

  const startYearNum = new Date(yearsView.value[0]).getFullYear();
  const endYearNum = new Date(yearsView.value[1]).getFullYear();

  // Track search query execution
  logUserAction(
    USER_ACTIONS.SEARCH_DASHBOARD,
    `Searched Prices: Commodity="${FILTERS.ELEMENT || 'N/A'}", Years=${startYearNum}-${endYearNum}`
  );

  await getPriceData(FILTERS.ELEMENT, FILTERS.PRODUCT, FILTERS.COUNTRY, startYearNum, endYearNum);
  leftAxisLabel.value  = products.value[0]?.value ?? '';
  rightAxisLabel.value = products.value.length > 1 ? products.value[1].value : products.value[0]?.value ?? '';
  const start = minYear.value; 
  const end = maxYear.value;
  
  if (!FILTERS.ELEMENT) {
    const start = minYear.value;
    const end = maxYear.value;

    yearsView.value = [
      (new Date((start == 'Infinity' || start == null ? 2015 : start), 0)).getTime(),
      (new Date((end == '-Infinity' || end == null ? 2035 : end), 0)).getTime(),
    ];
  }
  decimals.value = activeData.value[0]?.decimalPlaces ?? 1;
  getChartData();
  graphView.value = GRAPH_VIEW_OPTIONS.value[1].value;
  isSearch.value = true;
};

const options = ref({
  responsive: true, maintainAspectRatio: false, width: '100%', height: 700,
  plugins: { legend: { position: 'bottom', labels: { boxWidth: 20, padding: 15, color: 'black' }, onClick: () => { return; } } },
  scales: {
    x: { type: 'category', ticks: { color: 'black' }, grid: { drawOnChartArea: false } },
    yLeft: { min: 0, grid: { drawOnChartArea: false }, title: { display: true, text: '', font: { size: 16 }, color: 'black' }, ticks: { color: 'black', callback: (value) => Number(value).toLocaleString('en-US', { maximumFractionDigits: 2 }) } },
    yRight: { position: 'right', min: 0, grid: { drawOnChartArea: false }, title: { display: true, text: '', font: { size: 16 }, color: 'black' }, ticks: { color: 'black', callback: (value) => Number(value).toLocaleString('en-US', { maximumFractionDigits: 2 }) } },
  },
});
const optionsSingle = computed(() => ({
  responsive: true, maintainAspectRatio: false, width: '100%', height: 700,
  plugins: { legend: { position: 'bottom', labels: { boxWidth: 20, padding: 15, color: 'black' }, onClick: () => { return; } } },
  scales: {
    x: { type: 'category', ticks: { color: 'black' }, grid: { drawOnChartArea: false } },
    y: { min: 0, grid: { drawOnChartArea: false }, title: { display: true, text: axisTitle(leftAxisLabel.value), font: { size: 16 }, color: 'black' }, ticks: { color: 'black', callback: (value) => Number(value).toLocaleString('en-US', { maximumFractionDigits: 2 }) } },
  },
}));

watch([leftAxisLabel], (newVal) => { options.value.scales.yLeft.title.text = axisTitle(newVal); const value = graphView.value; graphView.value = ""; setTimeout(() => { graphView.value = value || GRAPH_VIEW_OPTIONS.value[1].value; getChartData(); }, 5); });
watch([rightAxisLabel], (newVal) => { options.value.scales.yRight.title.text = axisTitle(newVal); const value = graphView.value; graphView.value = ""; setTimeout(() => { graphView.value = value || GRAPH_VIEW_OPTIONS.value[1].value; getChartData(); }, 5); });
watch(yearsView, () => { if (activeData.value?.length) getChartData(); }, { deep: true });

// Track secondary axis switch
watch(isSingle, (val) => {
  if (!isMounted) return;
  logUserAction(
    USER_ACTIONS.FILTER_DASHBOARD,
    `Changed Prices axis mode to: "${val ? 'Single-axis' : 'Secondary axis'}" (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
});

// Track product series selection on chart axes
watch([leftAxisLabel, rightAxisLabel], ([newLeft, newRight], [oldLeft, oldRight]) => {
  if (!isMounted) return;
  if (newLeft === oldLeft && newRight === oldRight) return;
  logUserActionDebounced(
    USER_ACTIONS.FILTER_DASHBOARD,
    `Selected Prices chart series: Left="${newLeft || 'None'}", Right="${newRight || 'None'}" (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`,
    500
  );
});

// Full-page only: persist to sessionStorage
watch(() => FILTERS.ELEMENT, (newVal) => {
  if (!props.embedded) { 
    sessionStorage.setItem("element", newVal); 
  }
});

watch(graphView, () => {
  if (!chartData.value?.datasets?.length) return;
  if (graphView.value === 'bar') {
    chartData.value.datasets.forEach(ds => { ds.type = 'bar'; ds.stack = '1'; });
    options.value.scales.yLeft.stacked = true;
  } else if (graphView.value === 'line') {
    chartData.value.datasets.forEach(ds => { ds.type = 'line'; ds.fill = false; delete ds.stack; });
    options.value.scales.yLeft.stacked = false;
  } else {
    chartData.value.datasets.forEach(ds => { ds.type = 'line'; ds.fill = true; ds.stack = '1'; });
    options.value.scales.yLeft.stacked = true;
  }
});

watch(() => SUBSCRIPTION_INFO?.dataElements, async (newValue, oldValue) => {
  if (props.embedded) return;
  if (newValue?.length > 0 && oldValue?.length === 0) { FILTERS.ELEMENT = newValue[0].code; await getTableData(); }
}, { immediate: true });

const selectedElementInfo = computed(() => {
    if (!priceMetadata.value.length) return null;

    return {
        startYear: Math.min(
            ...priceMetadata.value.map(x => x.startYear)
        ),
        endYear: Math.max(
            ...priceMetadata.value.map(x => x.endYear)
        )
    };
});

watch(
    () => FILTERS.ELEMENT,
    async (newVal) => {

        if (!newVal) return;

        await getPriceMetadata(newVal);

        if (selectedElementInfo.value) {

            yearsView.value = [
                new Date(selectedElementInfo.value.startYear,0).getTime(),
                new Date(selectedElementInfo.value.endYear,0).getTime()
            ];
        }

        sessionStorage.setItem("element", newVal);

    }
);
const initializeFilters = async (element) => {
    if (!element) return;

    await getPriceMetadata(element);

    if (selectedElementInfo.value) {
        yearsView.value = [
            new Date(selectedElementInfo.value.startYear, 0).getTime(),
            new Date(selectedElementInfo.value.endYear, 0).getTime()
        ];
    }

    sessionStorage.setItem("element", element);
};

watch(
    () => FILTERS.ELEMENT,
    async (newVal) => {
        await initializeFilters(newVal);
        if (isMounted) needsRefresh.value = true;
    }
);

</script>

<style lang="scss">
.n-switch__checked,
.n-switch__unchecked {
  display: flex !important;
  align-items: center !important;
}
.dash-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  color: #000;
  font-size: 12px !important;
  font-weight: 400 !important;
  font-family: 'GilroyMedium', sans-serif;
  text-align: center;
  background: #f2f2f2;
}

/* ── Filter bar ── */
.dash-filterbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;  // wrap on narrow viewports

  .n-date-picker {
    .n-input {
      --n-border: 1px solid #e0e0e6 !important;
      --n-border-hover: 1px solid #2184ff !important;
      --n-border-focus: 1px solid #2184ff !important;
      --n-border-active: 1px solid #2184ff !important;
      --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
      --n-caret-color: #2184ff !important;
    }
    .n-date-panel {
      --n-item-color-active: #2184ff !important;
      --n-item-text-color-active: #fff !important;
      --n-item-color-hover: rgba(33, 132, 255, 0.1) !important;
    }
  }

  .n-base-selection {
    --n-border: 1px solid #e0e0e6 !important;
    --n-border-hover: 1px solid #2184ff !important;
    --n-border-focus: 1px solid #2184ff !important;
    --n-border-active: 1px solid #2184ff !important;
    --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
    --n-caret-color: #2184ff !important;
    --n-arrow-color-hover: #2184ff !important;
    --n-arrow-color-active: #2184ff !important;
  }
}

.dash-filterbar__select {
  // Grow to fill available space; shrink below 200px if needed; never go under 120px
  flex: 1 1 200px;
  min-width: 120px;
  max-width: 280px;
}

.dash-filterbar__date {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0; // keep date pair together — don't split label from picker
}

.dash-filterbar__label {
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}

.dash-filterbar__datepicker {
  width: 110px;
  min-width: 90px;
}

/* ── Action row ── */
.dash-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  row-gap: 0.25rem;  // let items flow onto a second line rather than overflow
}

// View-toggle buttons and export stay on one logical group; selects shrink gracefully
.dash-actions .n-select {
  flex: 1 1 130px;
  min-width: 110px;
  max-width: 180px;
}

// NSwitch shouldn't stretch
.dash-actions .n-switch {
  flex-shrink: 0;
}

.dash-action-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  color: #000;
  cursor: pointer;
  padding: 4px 10px 4px 4px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color 0.15s, border-color 0.15s;

  &--active {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:hover:not(&--active):not(:disabled) {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.dash-action-btn__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
}

// Disclaimer: push to far right on wide screens; on wrap it just sits at end of last line
.dash-actions__disclaimer {
  margin-left: auto;
  font-size: 11px;
  color: #9dabaf;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover { text-decoration: underline; }
}

// ── Narrow viewport overrides (< 640px) ──
@media (max-width: 639px) {
  .dash-filterbar__select {
    max-width: 100%;
    flex-basis: 100%; // commodity select takes full row on mobile
  }

  .dash-filterbar__date {
    flex: 1 1 auto; // start/end pickers share the row
  }

  .dash-filterbar__datepicker {
    width: 100%;
    min-width: 80px;
  }

  .dash-actions .n-select {
    flex-basis: calc(50% - 0.25rem); // two selects side by side on mobile
    max-width: none;
  }
}

.n-date-panel-actions__suffix > .n-button {
  display: none !important;
}

p {
  font-size: 14px !important;
  line-height: 1.625 !important;
  font-weight: 400 !important;
}

.split-menu {
  position: absolute;
  margin-top: 6px;
  width: 140px;
  background: white;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.split-menu button {
  width: 100%;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  padding: 6px 10px;
}

.split-menu button:hover {
  background: rgba(37, 99, 235, 0.08);
}

.n-data-table-td {
  white-space: nowrap !important;
}

.table-scroll.modern-scrollbar {
  overflow-x: auto;
  overflow-y: visible;
  height: auto;
}
</style>